var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseLink',{staticClass:"brand-card",attrs:{"link":_vm.link,"data-external":"brand-card"}},[_vm._t("default",function(){return [_c('div',{staticClass:"image-container"},[_c('BaseImage',{staticClass:"image",attrs:{"image-tag":"nuxt-img","src":_vm.imageSrc,"alt":_vm.imageAlt}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }